import React from 'react';
import { IconFill, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/upload.svg';

export default function UploadIcon(props: IconProps) {
  return <IconFill icon={Icon} {...props} />;
}
